import { useWatch, useFormContext } from "react-hook-form";
import React, { useEffect } from "react";
import { AutocompleteInput, TextInput } from "react-admin";
import { StateEnum } from "src/common/enum";

export const StateInput = () => {
    const {setValue} = useFormContext();
    const country = useWatch<{ country: string }>({ name: 'country' });
  
    useEffect(() => {
      setValue('state', '');
    }, [country]);
  
    return (
      country == 'US' ?
        <AutocompleteInput
          source="state"
          choices={StateEnum.slice(1)}
          size="small"
          sx={{
            "#state": { width: "100%" },
          }}
          emptyValue={""}
        />
      :
        <TextInput source="state" label="State / Region"/>
    );
};